import { Route, Routes } from "react-router-dom"
import AddJobDetail from "./pages/AddNewJobDetail"
import EditJobDetail from "./pages/EditJobDetail"
import List from "./pages/List"

export const JobDetailRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/create" element={<AddJobDetail />} />
      <Route path="/:id" element={<EditJobDetail />} />
    </Routes>
  )
}
